import withFormBlock from '../FormBlock/withFormBlock'
import AsyncSelectInput, { AsyncSelectInputProps } from './AsyncSelectInput'

export default withFormBlock<AsyncSelectInputProps>(AsyncSelectInput)
